import { createSlice } from "@reduxjs/toolkit";
import { AuthInitialState } from "./auth.type";

const initialState: AuthInitialState = {
  user: undefined,
  role: undefined,
  access_token: undefined,
  notificationToken: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userLoggedIn: (state, action) => {
      state.access_token = action.payload?.access_token;
    },
    userLoggedOut: (state) => {
      state.access_token = undefined;
      state.user = undefined;
      state.role = undefined;
    },
    setAuthInfo: (state, action) => {
      state.user = action?.payload;
      state.role = action?.payload?.role;
    },
    setNotificationToken: (state, action) => {
      state.notificationToken = action.payload;
    },
  },
});

export const {
  userLoggedIn,
  userLoggedOut,
  setAuthInfo,
  setNotificationToken,
} = authSlice.actions;
export default authSlice.reducer;
